
import React from 'react';
import './FaqPage.css';


import FaqHero from "../../components/FAQPage/FaqHero/FaqHero"

import FaqAccordionSection from '../../components/FAQPage/FaqAccordionSection/FaqAccordionSection'; 


const FaqPage = () => {
  return (
    <div className="faq-page-wrapper">
      <FaqHero />
      <FaqAccordionSection /> 
    </div>
  );
};

export default FaqPage;